var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"template-editor"},[_c('Header'),_c('div',{staticClass:"body"},[_c('TabsSelector'),_c('div',{staticClass:"tabs"},[_c(_vm.selectedTab,{tag:"component"})],1),_c('Canvas',{attrs:{"editable":!_vm.isPrinting}})],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }